/**
 * TanStack Query hooks for `offer-checker-tool`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	offerCheckerToolQueryKeys,
	type CreateOfferCheckerToolBody,
	type ListOfferCheckerToolResponse,
	type OfferCheckerToolRow,
} from "./api";

export function useOfferCheckerToolList(): UseQueryResult<ListOfferCheckerToolResponse, Error> {
	return useQuery({
		queryKey: offerCheckerToolQueryKeys.list(),
		queryFn: list,
	});
}

export function useOfferCheckerToolCreate(): UseMutationResult<OfferCheckerToolRow, Error, CreateOfferCheckerToolBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: offerCheckerToolQueryKeys.all });
		},
	});
}

export function useOfferCheckerToolDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: offerCheckerToolQueryKeys.all });
		},
	});
}
